"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidAddonIdFromOldAddonAndNewLocation = exports.addonsForCurrency = void 0;
const addons_1 = require("./addons");
const currencies_1 = require("./currencies");
const get_location_plans_1 = require("./get-location-plans");
exports.addonsForCurrency = {
    GBP: {
        business: {
            tier1: {
                current: 'tier-1-v3-gbp',
            },
            tier2: {
                current: 'tier-2-v3-gbp',
            },
            tier3: {
                current: 'tier-3-v3-gbp',
            },
        },
        family: {
            adult: {
                current: 'adult-v3-gbp',
            },
            child: {
                current: 'child-v3-gbp',
            },
            pet: {
                current: 'pet-v3-gbp',
            },
        },
    },
    USD: {
        business: {
            tier1: {
                current: 'tier-1-v3-usd',
            },
            tier2: {
                current: 'tier-2-v3-usd',
            },
            tier3: {
                current: 'tier-2-v3-usd',
            },
        },
        family: {
            adult: {
                current: 'adult-v3-usd',
            },
            child: {
                current: 'child-v3-usd',
            },
            pet: {
                current: 'pet-v3-usd',
            },
        },
    },
    EUR: {
        business: {
            tier1: {
                current: 'tier-1-v3-eur',
            },
            tier2: {
                current: 'tier-2-v3-eur',
            },
            tier3: {
                current: 'tier-3-v3-eur',
            },
        },
        family: {
            adult: {
                current: 'adult-v3-eur',
            },
            child: {
                current: 'child-v3-eur',
            },
            pet: {
                current: 'pet-v3-eur',
            },
        },
    },
    AUD: {
        business: {
            tier1: {
                current: 'tier-1-v3-aud',
            },
            tier2: {
                current: 'tier-2-v3-aud',
            },
            tier3: {
                current: 'tier-3-v3-aud',
            },
        },
        family: {
            adult: {
                current: 'adult-v3-aud',
            },
            child: {
                current: 'child-v3-aud',
            },
            pet: {
                current: 'pet-v3-aud',
            },
        },
    },
    CAD: {
        business: {
            tier1: {
                current: 'tier-1-v3-cad',
            },
            tier2: {
                current: 'tier-2-v3-cad',
            },
            tier3: {
                current: 'tier-3-v3-cad',
            },
        },
        family: {
            adult: {
                current: 'adult-v3-cad',
            },
            child: {
                current: 'child-v3-cad',
            },
            pet: {
                current: 'pet-v3-cad',
            },
        },
    },
};
const addonsForUSMedium = {
    business: {
        tier1: {
            current: 'tier-1-v3-usd-medium',
        },
        tier2: {
            current: 'tier-2-v3-usd-medium',
        },
        tier3: {
            current: 'tier-2-v3-usd-medium',
        },
    },
    family: {
        adult: {
            current: 'adult-v3-usd-medium',
        },
        child: {
            current: 'child-v3-usd-medium',
        },
        pet: {
            current: 'pet-v3-usd-medium',
        },
    },
};
/**
 * Given the existing addon what is the corresponding addonId to select for the new currency ?
 * Note - we can't switch a user to a USMedium addon based solely on the new currency we would need to take their
 * location into account as well
 * @param {string} oldAddonId - The identifier of the existing addonId the user has
 * @param {Location} newLocation - The new location the user is changing their account over to
 * @return {string}
 */
const getValidAddonIdFromOldAddonAndNewLocation = (oldAddonId, newLocation) => {
    let newAddonId = null;
    const isTierOne = (0, addons_1.isTierOneAddon)(oldAddonId);
    const isTierTwo = (0, addons_1.isTierTwoAddon)(oldAddonId);
    const isTierThree = (0, addons_1.isTierThreeAddon)(oldAddonId);
    const isAdult = (0, addons_1.isAdultAddon)(oldAddonId);
    const isChild = (0, addons_1.isChildAddon)(oldAddonId);
    const isPet = (0, addons_1.isPetAddon)(oldAddonId);
    const newCurrencyCode = currencies_1.locationCurrencyCodeMapper[newLocation.countryCode];
    const canUseUSMedium = (0, get_location_plans_1.isUSMediumLocation)(newLocation);
    if ((0, addons_1.isBusinessAddon)(oldAddonId)) {
        if (isTierOne) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.business.tier1.current
                : exports.addonsForCurrency[newCurrencyCode].business.tier1.current;
        }
        else if (isTierTwo) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.business.tier2.current
                : exports.addonsForCurrency[newCurrencyCode].business.tier2.current;
        }
        else if (isTierThree) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.business.tier3.current
                : exports.addonsForCurrency[newCurrencyCode].business.tier3.current;
        }
    }
    else if ((0, addons_1.isFamilyAddon)(oldAddonId)) {
        if (isAdult) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.family.adult.current
                : exports.addonsForCurrency[newCurrencyCode].family.adult.current;
        }
        else if (isChild) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.family.child.current
                : exports.addonsForCurrency[newCurrencyCode].family.child.current;
        }
        else if (isPet) {
            newAddonId = canUseUSMedium
                ? addonsForUSMedium.family.pet.current
                : exports.addonsForCurrency[newCurrencyCode].family.pet.current;
        }
    }
    return newAddonId;
};
exports.getValidAddonIdFromOldAddonAndNewLocation = getValidAddonIdFromOldAddonAndNewLocation;
//# sourceMappingURL=data:application/json;base64,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